import { Grid } from '@aloft/toolkit-sui';

import { selectSubjectIsManufacturedHome } from '../../redux/features/selectors/propertyDataSelectors/improvementsSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { DefaultEcoLifeInput } from './DefaultEcoLifeInput.tsx';

export const JointDefaultEcoLifeInput = () => {
  const subjectIsManufactured = useAppSelector(selectSubjectIsManufacturedHome);
  return subjectIsManufactured ? (
    <Grid gridTemplateColumns="repeat(2, 1fr)" columnGap=".75rem">
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeManufactured" label="Manufactured House" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLife" label="Site-Built Dwelling" />
    </Grid>
  ) : (
    <DefaultEcoLifeInput fieldPath="defaultEcoLife" />
  );
};
